var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77832 14.222C1.77832 15.2043 2.57384 15.9998 3.55606 15.9998H10.667C11.6492 15.9998 12.4447 15.2043 12.4447 14.222V3.55566H1.77832V14.222Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2222 0.88885L9.33334 0H4.88905L4.00016 0.88885H0.88916V2.66659H13.3332V0.88885H10.2222Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesDelete);
export default __webpack_public_path__ + "static/media/rolesDelete.59ea1472dfd98ab4882974ac37ac21d3.svg";
export { ForwardRef as ReactComponent };